import { useEffect } from 'react'
import { Analytics } from '@vercel/analytics/react'
import { useCookieConsentContext } from './CookieConsentProvider'
import { applyScriptConsent } from '../../lib/analytics'

export function ConsentScriptGate() {
  const { initialized, consent } = useCookieConsentContext()

  useEffect(() => {
    if (!initialized) return
    applyScriptConsent(consent)
  }, [initialized, consent])

  if (!initialized || !consent.analytics) return null

  return (
    <Analytics
      beforeSend={(event) => {
        if (event.url.includes('/psychologist-dashboard')) {
          const url = new URL(event.url)
          url.pathname = '/psychologist-dashboard'
          url.search = ''
          url.hash = ''
          return { ...event, url: url.toString() }
        }
        return event
      }}
    />
  )
}
